var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('carousel',{staticClass:"mt-10",attrs:{"perPage":1}},_vm._l((_vm.images),function(image,index){return _c('slide',{key:index},[_c('img',{class:'' + _vm.img_size,attrs:{"src":require('@/assets/projects/' + image)}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }